import { useEffect, useState } from 'react'

/**
 * A shared clock for the running timer. One interval, aligned to the next second
 * boundary so the digits change when the clock does.
 */
export function useTick(periodMs = 1000): number {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    let interval: ReturnType<typeof setInterval> | undefined
    const align = setTimeout(
      () => {
        setNow(Date.now())
        interval = setInterval(() => setNow(Date.now()), periodMs)
      },
      periodMs - (Date.now() % periodMs),
    )
    return () => {
      clearTimeout(align)
      if (interval) clearInterval(interval)
    }
  }, [periodMs])
  return now
}
